import React from "react";

const LayoutButtonWrapper = ({children}) => {

    return (
        <div className="flex justify-center items-center align-middle w-full" >
            <div style={{
                zIndex: 100,
                width: '100%',
                height: 'fit-content',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'space-between',
                gap: 8,
            }}>
                {children}
            </div>
        </div>
    )
};

export default LayoutButtonWrapper;